<template>
  <div class="crpg-a-private-cruising-photo-gallery">
    <img
      :src="require(`@/assets/img/privateCruising/${this.path}`)"
      @click="zoomEvent"
    />
  </div>
</template>

<script>
export default {
  name: "AtomsPrivateCruisingPhotoGallery",
  props: {
    path: {
      String: "",
    },
  },
  methods: {
    zoomEvent() {
      this.$store.dispatch("zoom/show", ["privateCruising", this.path]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/atoms/privateCruising/photoGallery.scss";
</style>
